import { useEffect, useMemo, useState } from "react";
import { ExpandLess, ExpandMore, } from "@mui/icons-material";
import { Grid, IconButton, List, ListItem, Icon } from "@mui/material";

import Box from "../Box";
import Avatar from "../Avatar";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";
import Strings from "../../constants/strings";
import ButtonSwitcherLanguage from "./buttonSwitcherLanguage";

import { listItem, icon, flag } from "./styles";
import { IItemRoute, IRecordMenu } from "../../commons/interfaces";



interface IProps {
    logoApp: string;
    titleApp: string;
    language: string;
    openMenu: boolean;
    dataMenu: IRecordMenu[];

    handleDrawerToggle?: () => void;
    onNavigate: (pathName: string) => void;
    onChangeLanguage: (lang: string) => void;

    pathNameCurrent: string;
    pathNameDefault?: string;
    dataMapScreenName?: { [key: string]: JSX.Element };
    listPathName?: { pathName: string, query: string, totalCount: number }[];
}

const MenuBarEliminateRecursion = (props: IProps) => {

    const openMenu = useMemo(() => props.openMenu, [props.openMenu]);
    const mainDataMenu = useMemo(() => props.dataMenu, [props.dataMenu]);

    const pathNameDefault: string = useMemo(() => (props.pathNameDefault || "/"), [props.pathNameDefault]);
    const pathNameCurrent: string = useMemo(() => (props.pathNameCurrent || "/"), [props.pathNameCurrent]);

    const [arrKeySelected, setArrKeySelected] = useState<string[]>([]);
    const [arrKeyOnClicked, setArrKeyOnClicked] = useState<string[]>([]);

    const [listItemMenuShow, setListItemMenuShow] = useState<IItemRoute[]>([]);
    const [listSubMenuMap, setListSubMenuMap] = useState<{ [key: string]: IItemRoute[] }>({});

    useEffect(() => {
        if (openMenu === false) {
            setArrKeyOnClicked(arrKeySelected);
        }
    }, [openMenu]);

    useEffect(() => {
        const resultData = convertIRecordMenuToIItemRoute({
            data: mainDataMenu,
            language: props.language,
            dataMapScreenName: props.dataMapScreenName,
        });

        setListSubMenuMap(resultData.subMenuMap);
        setListItemMenuShow(resultData.menuParents);

        if ((resultData.menuParents.length > 0) && !Helpers.isNullOrEmpty(pathNameCurrent)) {
            const itemTemp = resultData.menuParents.find(el => (el.screenPath === pathNameCurrent));

            if (itemTemp) {
                let val = [];

                for (let index = 0; index < (itemTemp?.key?.length / 5); index++) {
                    val.push(itemTemp?.key?.slice(0, 5 * (index + 1)))
                }

                setArrKeyOnClicked(val);
                setArrKeySelected([itemTemp?.key]);
            } else {
                return;
            }
        } else {
            setArrKeySelected([]);
            setArrKeyOnClicked([]);
        }
    }, [mainDataMenu, pathNameCurrent, props.dataMapScreenName, props.language]);

    const handelOnClickItemMenu = (itemMenu: IItemRoute, index: number) => {
        if ([...listSubMenuMap?.[itemMenu?.key] || []].findIndex(el => (el.isVisible === true)) === -1) {
            const itemPathName = [...props.listPathName || []].find(el => (el.pathName === itemMenu?.screenPath));

            const pathNameNavigate = itemPathName ? (itemPathName?.pathName + itemPathName?.query) : itemMenu?.screenPath;

            Helpers.isFunction(props.handleDrawerToggle) && props.handleDrawerToggle();

            if (Helpers.isNullOrEmpty(itemMenu?.target)) {
                props.onNavigate(pathNameNavigate)
            } else {
                window.open(`${pathNameNavigate}`, `${itemMenu?.target}`);
            }

        } else {
            const arrItemTemp: string[] = [...arrKeyOnClicked || []];

            if (arrItemTemp.findIndex(el => el === itemMenu?.key) === -1) {
                if (itemMenu?.key?.length <= 5) {
                    setArrKeyOnClicked([itemMenu?.key]);
                } else {
                    setArrKeyOnClicked(prev => ([...prev, itemMenu?.key]));
                }
            } else {
                const temp = arrItemTemp.filter(el => !(el.startsWith(itemMenu?.key)));
                setArrKeyOnClicked(temp);
            }
        }
    }

    const handelKeyActiveSelected = (valueKey: string) => {
        const checked = arrKeySelected.find(el => el.startsWith(valueKey));
        return checked ? true : false;
    }

    const handelKeyActiveOnClicked = (valueKey: string) => {
        const checked = arrKeyOnClicked.find(el => el.startsWith(valueKey));
        return checked ? true : false;
    }

    const handelShowItemMenu = (valueKey: string) => {
        const length = valueKey.length;
        const checked = arrKeyOnClicked.find(el => (
            valueKey.startsWith(el) && (length <= (el.length + 5))
        ));
        return checked ? true : false;
    }

    const renderIconItemMenu = (itemMenu: IItemRoute) => {
        if (!itemMenu?.hidenIcon) {
            if (Helpers.isNullOrEmpty(itemMenu?.icon) && Helpers.isNullOrEmpty(itemMenu?.iconName)) {
                return (
                    <Box sx={icon}>
                        {!props.openMenu ?
                            <Typography color="white">
                                {Helpers.removeAccentsFromStrings(`${itemMenu?.title || ""}`.substring(0, 1))}
                            </Typography>
                            : null
                        }
                    </Box>
                );
            } else {
                if (!Helpers.isNullOrEmpty(itemMenu?.iconName)) {
                    return (
                        <Icon sx={icon}>
                            {itemMenu?.iconName}
                        </Icon>
                    );
                }

                if (!Helpers.isNullOrEmpty(itemMenu?.icon)) {
                    return (<Box sx={icon}>{itemMenu?.icon}</Box>);
                }

                return (
                    <Box sx={icon}>
                        {!props.openMenu ?
                            <Typography
                                variant="button"
                                fontWeight="regular"
                                textTransform="none"
                                style={{ color: "#ffffff" }}
                            >
                                {Helpers.removeAccentsFromStrings(`${itemMenu.title}`).substring(0, 1).toUpperCase()}
                            </Typography>
                            : null
                        }
                    </Box>
                );
            }
        } else {
            return (
                <Box sx={icon}>
                    {!props.openMenu ?
                        <Typography
                            variant="button"
                            fontWeight="regular"
                            textTransform="none"
                            style={{ color: "#ffffff" }}
                        >
                            {Helpers.removeAccentsFromStrings(`${itemMenu.title}`).substring(0, 1).toUpperCase()}
                        </Typography>
                        : null
                    }
                </Box>
            );
        }
    }

    const renderItemMenu = (itemMenu: IItemRoute, index: number) => {
        const isParent = ([...listSubMenuMap?.[itemMenu?.key] || []].findIndex(el => (el.isVisible === true)) !== -1);

        const isVisible = (itemMenu?.key?.length === 5)
            ? itemMenu?.isVisible
            : (itemMenu?.isVisible && handelShowItemMenu(itemMenu?.key));

        return (
            <Box
                key={itemMenu?.key}
                style={{ display: isVisible ? "block" : "none", }}
            >
                <ListItem style={{ paddingBottom: "4px", paddingTop: "4px", }}>
                    <IconButton
                        onClick={() => { handelOnClickItemMenu(itemMenu, index) }}
                        sx={(theme) => listItem(theme,
                            {
                                isParent: isParent,
                                openMenu: openMenu,
                                isActive: handelKeyActiveSelected(itemMenu?.key) ? true : false,
                            })}
                    >
                        <Box style={{
                            display: "flex",
                            alignItems: "center",
                            maxWidth: `calc(100% - ${isParent ? "24px" : "0px"})`,
                            marginLeft: `${(itemMenu.key.length - 5) / 5 * 12}px`,
                        }}>
                            {renderIconItemMenu(itemMenu)}
                            {
                                openMenu &&
                                <Box sx={{ display: "flex", maxWidth: `calc(100% - 28px)` }}>
                                    <Typography
                                        variant="button"
                                        fontWeight="regular"
                                        textTransform="none"
                                        style={{
                                            color: "#ffffff",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {itemMenu?.title}
                                    </Typography>
                                </Box>
                            }
                        </Box>
                        {isParent
                            ? handelKeyActiveOnClicked(itemMenu?.key)
                                ? <ExpandLess htmlColor={"#ffffff"} />
                                : <ExpandMore htmlColor={"#ffffff"} />
                            : null
                        }
                    </IconButton>
                </ListItem>
            </Box>
        )
    }

    return (
        <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", minHeight: "100%" }}>
            <Grid>
                <ListItem
                    onClick={() => { props.onNavigate(pathNameDefault) }}
                    style={{ paddingBottom: "4px", justifyContent: "center" }}
                >
                    {props.openMenu
                        ? <Typography
                            textAlign="center"
                            style={{
                                color: "#ffffff",
                                fontSize: openMenu ? "32px" : "20px",
                            }}>
                            {props.titleApp || ""}
                        </Typography>
                        : <img alt="logo_menu" src={props.logoApp} width={55} height={55} />
                    }
                </ListItem>
                <List>
                    {listItemMenuShow?.map((item, index) => renderItemMenu(item, index))}
                </List>
            </Grid>

            {/* Button Switcher Language  */}
            <Grid sx={(theme) => flag(theme, openMenu)} >
                <ButtonSwitcherLanguage
                    isMiniSideNav={!openMenu}
                    handleOnChange={(valLanguage) => {
                        Strings.setLanguage(valLanguage);
                        props.onChangeLanguage(valLanguage);
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default MenuBarEliminateRecursion;


const convertIRecordMenuToIItemRoute = (props: {
    language: string,
    data: IRecordMenu[],
    dataMapScreenName: { [key: string]: JSX.Element },
}) => {
    const menuParents: IItemRoute[] = [];
    const subMenuMap: { [key: string]: IItemRoute[] } = {};

    props.data.forEach((element: IRecordMenu) => {
        let iconElement: JSX.Element | undefined = undefined;
        const hidenIcon = Helpers.isNullOrEmpty(element.icon) && Helpers.isNullOrEmpty(element.iconUrl);
        const title = Helpers.renderValueByLanguage({ data: element.title, currentLanguage: props.language });

        if (!Helpers.isNullOrEmpty(element.iconUrl)) {
            iconElement = <Avatar src={element.iconUrl} style={{ width: "24px", height: "24px" }} />
        }

        const newItemRoute = {
            key: element.gene,
            isVisible: true,
            screenPath: element.externalUrl || "",
            screenName: props.dataMapScreenName[`${element.screenName}`],

            title: title,
            icon: iconElement,
            hidenIcon: hidenIcon,
            iconName: element.icon,
            resourceCode: element.resourceURI,
        };


        if ((Helpers.isNullOrEmpty(element.parentMenu) || element.parentMenu === "0") && (element.gene?.length === 5)) {
            menuParents.push(newItemRoute);
        } else {
            const parentGene: string = element.gene.slice(0, element.gene.length - 5);

            if (!subMenuMap[parentGene]) {
                subMenuMap[parentGene] = [newItemRoute];
            } else {
                subMenuMap[parentGene].push(newItemRoute);
            }
        }

        // 
        if (!Helpers.isNullOrEmpty(element.extraInformation)) {
            const extraInformation = Helpers.converStringToJson(element.extraInformation);

            if (Array.isArray(extraInformation)) {
                extraInformation.forEach((el) => {
                    const newItemSubRoute: IItemRoute = {
                        isVisible: false,
                        key: el.Gene || el.gene,
                        resourceCode: el.ResourceURI || el.resourceURI,
                        screenPath: el.ScreenPath || el.screenPath || "",
                        screenName: props.dataMapScreenName[`${el.ScreenName || el.screenName}`],
                        title: "",
                    }
                    if (!subMenuMap[element.gene]) {
                        subMenuMap[element.gene] = [newItemSubRoute];
                    } else {
                        subMenuMap[element.gene].push(newItemSubRoute);
                    }
                });
            } else {
                const newItemSubRoute: IItemRoute = {
                    isVisible: false,
                    key: extraInformation?.Gene || extraInformation?.gene,
                    resourceCode: extraInformation?.ResourceURI || extraInformation?.resourceURI,
                    screenPath: extraInformation?.ScreenPath || extraInformation?.screenPath || "",
                    screenName: props.dataMapScreenName[`${extraInformation?.ScreenName || extraInformation?.screenName}`],
                    title: "",
                }
                if (!subMenuMap[element.gene]) {
                    subMenuMap[element.gene] = [newItemSubRoute];
                } else {
                    subMenuMap[element.gene].push(newItemSubRoute);
                }
            }
        }
    });

    let newDataReturn: IItemRoute[] = [];
    menuParents.forEach((element) => {
        newDataReturn.push(element);
        if (subMenuMap?.[element.key]) {
            const subTemp = getSubRoute(subMenuMap?.[element.key], subMenuMap);
            newDataReturn = [...newDataReturn, ...subTemp];
        }
    });

    return ({
        subMenuMap: subMenuMap,
        menuParents: newDataReturn,
    });
}

const getSubRoute = (
    menuParents: IItemRoute[],
    subMenuMap: { [key: string]: IItemRoute[] }
) => {
    let newSubRoute: IItemRoute[] = [];

    menuParents.forEach((element: IItemRoute) => {
        newSubRoute.push(element);
        if (subMenuMap?.[element.key]) {
            const subTemp = getSubRoute(subMenuMap?.[element.key], subMenuMap);
            newSubRoute = [...newSubRoute, ...subTemp];
        }
    });

    return newSubRoute;
}